export default "__VITE_ASSET__BQoEPYlf__"